import { Component, Event, EventEmitter, getAssetPath, h, Host, Prop, State } from '@stencil/core';

import wcShared from '@web-components/shared';

import helpdeskCommon from '../../../../utils/HelpdeskCommon.class';
import { FaqsStore } from '../../../../utils/Stores/faqs-store';
import { Store } from '../../../../utils/Stores/store';

@Component({
  tag: 'faq-item-module',
  styleUrl: 'faq-item-module.scss',
  shadow: true,
})
export class ModuleFaqItem {
  @Prop({ mutable: true }) faq: IWCFaq = FaqsStore?.get('current');
  @State() hasVoted = false;
  @State() loadingFaq = false;
  @State() visibilityModal = false;

  @Event() openSupportModuleFaq: EventEmitter<number>;
  @Event() backEvent: EventEmitter;
  @Event() sectionChangeEvent: EventEmitter<IWCContextClose[]>;

  componentWillRender() {
    if (this.faq && !Boolean(this.faq.title)) {
      this.getFaq(this.faq.id);
    }
  }

  private putFaq(vote: boolean, id: number) {
    wcShared
      .httpCall('PUT', '/api/components/support/faq/' + id + '/vote', { vote: +vote })
      .then((r) => {
        if (r.status === 200) {
          r.json().then(() => {
            this.hasVoted = true;
          });
        }
      });
  }

  private closeModal = (event) => {
    event.stopPropagation();
    document?.querySelector('#wcModalImage').remove();
    this.visibilityModal = false;
    removeEventListener('click', this.closeModal);
  };

  private openImage(event: MouseEvent) {
    if ((event.target as HTMLElement).tagName.toLowerCase() === 'img') {
      if (this.visibilityModal) {
        document?.querySelector('#wcModalImage').remove();
        this.visibilityModal = false;
      } else {
        const myDiv = document.createElement('div');
        myDiv.innerHTML = `
          <div id="wcModalImage" style="position: fixed;top: 0;width: 100%;height: 100%;background: rgba(0,0,0,0.6);left: 0;margin: 0;display: block;z-index: 100000;padding: 50px;box-sizing: border-box;">
            <div class="wc-image__close" style="
            position: absolute;
            right: 20px;
            top: 20px;
            cursor: pointer;
            "
            >
              <img id="closeModal" src="${getAssetPath(
                './../assets/icons/white-cross.svg',
              )}" alt="${wcShared?.translate(
                'Close',
              )}" style="padding: 10px; background: white; border-radius:50%"/>
            </div>
              <div style="height: 100%; width: 100%;">
                <img id="wc-image__image" src="${(event.target as HTMLElement).getAttribute(
                  'src',
                )}" style="
                max-width: 100%;
                height: auto;
                display: block;
                position: relative;
                margin: auto;
                top: 50%;
                transform: translateY(-50%);
            "></img>
              </div>
            </div>
          </div>`;
        //Add your content to the DIV
        document?.body?.appendChild(myDiv);
        this.visibilityModal = true;
        document?.querySelector('#wcModalImage').addEventListener('click', this.closeModal);
      }
    }
  }

  private getFaq(id: number) {
    this.loadingFaq = true;
    wcShared?.store?.loaderStart('loadingFaq');

    let url = `/api/components/chatbot/faq/search?lang=${wcShared?.store?.getLang()}`;
    url += helpdeskCommon.urlFormatFaq(null, id);

    return wcShared
      .httpCall('GET', url)
      .then((r) => {
        if (r.status === 200) {
          r.json().then((response) => {
            this.faq = response.data.faq[0];
            wcShared?.store?.loaderStop('loadingFaq').then(() => (this.loadingFaq = false));
          });
        }
      })
      .catch(() => {
        wcShared?.store?.loaderStop('loadingFaq').then(() => (this.loadingFaq = false));
      });
  }

  private back() {
    this.backEvent.emit();
  }

  private goToFaqs() {
    this.sectionChangeEvent.emit(['faq_list']);
  }

  render() {
    if (this.loadingFaq) {
      return <module-loader-component />;
    } else {
      return (
        <Host>
          <div
            id="support-faq__view"
            class={{ 'support-faq__view--full': Store?.get('is_full') }}
          >
            <div>
              <div id="faq-view__title">
                <div class="rectangle-copy"></div>
                <div class="rectangle-copy-2"></div>
                <div class="rectangle-copy-7"></div>
                <div class="rectangle-copy-8"></div>
                <div class="faq-header-title">
                  <h2>{this.faq?.title}</h2>
                  <div class="faq-services-list">
                    {this.faq?.services
                      ?.filter((elem) => elem.label)
                      .map((service) => {
                        return <div class="faq-service">{service?.label}</div>;
                      })}
                  </div>
                </div>
              </div>
              <div
                id="faq-view__description"
                onClick={(event) => this.openImage(event)}
                innerHTML={this.faq?.answer}
              ></div>
              <div
                id="faq-utility"
                class={{ hide: this.faq?.has_voted || this.hasVoted }}
              >
                <div class="separator"></div>
                <h4>{wcShared.translate('Cette FAQ vous a ete utilie ?')}</h4>
                <div id="faq-utility-buttons">
                  <button onClick={() => this.putFaq(true, this.faq?.id)}>
                    <img
                      src={getAssetPath('./../assets/icons/like.svg')}
                      alt="Like"
                    />
                    {wcShared.translate('Oui')}
                  </button>
                  <button onClick={() => this.putFaq(false, this.faq?.id)}>
                    <img
                      src={getAssetPath('./../assets/icons/like.svg')}
                      alt="Like"
                    />
                    {wcShared.translate('Non')}
                  </button>
                </div>
              </div>
              <div
                id="faq-utility-voted"
                class={{ hide: !this.hasVoted }}
              >
                <div class="separator"></div>
                <div class="flex align-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z" />
                  </svg>
                  <p>{wcShared.translate('Merci, votre vote a bien ete pris en compte')}</p>
                </div>
              </div>
              <div class="separator-small"></div>
              <div>
                <p class="faq-url">
                  {wcShared.translate('Lien vers cette FAQ:')}
                  <a
                    target="_blank"
                    href={this.faq?.short_url}
                  >
                    {this.faq?.short_url}
                  </a>
                </p>
              </div>
              <div id="support-faq__buttons">
                <div
                  id="support-button__faqs"
                  class={{ center: Store?.get('routing')?.length <= 1 }}
                >
                  <div
                    class={{ hide: Store?.get('routing')?.length <= 1 }}
                    id="support-buttons__back-faq"
                  >
                    <button
                      onClick={() => {
                        this.back();
                      }}
                    >
                      {wcShared.translate('Retour')}
                    </button>
                  </div>
                  <div id="support-buttons__all">
                    <button onClick={() => this.goToFaqs()}>
                      {wcShared.translate('Consulter toutes les FAQs')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Host>
      );
    }
  }
}
